import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=1a09d9f9&"
import script from "./AboutUsPage.vue?vue&type=script&lang=js&"
export * from "./AboutUsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports